import type { IAccountMeta } from "@/shared/common/types";
import { AccountSelectOption } from "@/shared/components";
import { components } from "@ab.uitools/ui-library/components/ReactSelect";
import type { OptionProps, TOption } from "@ab.uitools/ui-library/components/ReactSelect/types";

export const CommissionAccountSelectOption = (props: OptionProps<TOption>) => {
  const meta = props.data?.meta as IAccountMeta;
  return (
    <components.Option
      {...props}
      innerProps={{
        ...props.innerProps,
        onMouseMove: undefined,
        onMouseOver: undefined,
      }}
    >
      <AccountSelectOption
        {...meta}
        index={meta.index}
        isSelected={props.isSelected}
      />
    </components.Option>
  );
};
